const documentCache = function(node, includePath = false, includeNode = true) {
  let documentIdCache = {};
  let documentPathCache = {};

  const recurseThroughTree = function(node, path, includePath) {
    if (includePath) {
      node.path = path;
    }

    if (includeNode) {
      documentIdCache[node.documentId] = {
        path,
        documentId: node.documentId,
        title: node.title,
        children: node.children,
        slug: node.slug,
        node
      };
      documentPathCache[node.path] = {
        path,
        documentId: node.documentId,
        title: node.title,
        children: node.children,
        slug: node.slug,
        node
      };
    } else {
      documentIdCache[node.documentId] = {
        path,
        documentId: node.documentId,
        title: node.title,
        children: node.children,
        slug: node.slug
      };
      documentPathCache[node.path] = {
        path,
        documentId: node.documentId,
        title: node.title,
        children: node.children,
        slug: node.slug
      };
    }

    for (let i = 0; i < node.children.length; i++) {
      let childPath = path + "/" + node.children[i].slug;
      recurseThroughTree(node.children[i], childPath, includePath);
    }
  };

  recurseThroughTree(node, node.slug, includePath);
  return { documentIdCache, documentPathCache };
};

export default documentCache;
